module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "opsgenie-right.77c52ee2.svg";